import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "locationInput",
    ]

    locationSelected(event) {
        this.dispatch("locationSelected", { detail: { location: this.locationInputTarget.value } })
    }
}